import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { invoicesApi } from "@/lib/api/invoices";
import { Loader2 } from "lucide-react";
import {
  InvoiceReceiptDocument,
  type InvoiceReceiptData,
} from "@/components/receipt/InvoiceReceiptDocument";

export function InvoiceReceiptPage() {
  const { id } = useParams<{ id: string }>();
  const [receipt, setReceipt] = useState<InvoiceReceiptData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    invoicesApi
      .getReceipt(id)
      .then(setReceipt)
      .catch((e) => setError(e.response?.data?.message || "Failed to load receipt"))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div
        className="flex min-h-screen items-center justify-center bg-slate-50 px-4"
        role="status"
        aria-live="polite"
      >
        <Loader2 className="h-8 w-8 animate-spin text-primary" aria-hidden />
        <span className="sr-only">Loading receipt</span>
      </div>
    );
  }

  if (error || !receipt) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4 py-10">
        <p className="max-w-md text-center text-sm leading-relaxed text-red-800">
          {error || "Receipt not found"}
        </p>
      </div>
    );
  }

  return (
    <InvoiceReceiptDocument receipt={receipt} backHref="/invoices" backLabel="Back to invoices" />
  );
}
